import { Injectable } from '@angular/core';
import { LogService } from './log.service';
import { SessionStorageService } from './session-storage.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, of } from 'rxjs';
import { OverlayRecord } from '../types/overlay/overlay-record';
import { map } from 'rxjs/operators';
import { MrnFacilityPair } from '../types/overlay/mrn-facility-pair';

@Injectable({
  providedIn: 'root'
})
export class NPSScoringService {
  private api = environment.api;
  public userComments: string;
  constructor(
    private log: LogService,
    private storageService: SessionStorageService,
    private http: HttpClient
  ) {
  }
  
  resetNpsExpiration()  {
    console.log('resetNpsExpiration entered');
    const url = this.getUrl(this.api.npsExpiration, {
      uuxSessionId: this.storageService.getUUXSessionId()
    });
    console.log('resetNpsExpiration.url', url);
    return this.http.get<any>(url);
  }
  getUrl(baseUrl: string, params?: any) {
    if (!params) {
      return baseUrl;
    }
    else {
      return baseUrl + '?' + this.encodeData(params);
    }
  }

  private encodeData(data: any): string {
    return Object.keys(data)
      .map(key => {
        return [key, data[key]].map(encodeURIComponent).join('=');
      })
      .join('&');
  }
}